import { useEffect, useState } from 'react';

const nodes = [
  { label: 'XAUUSD MARKET', tag: 'INGEST' },
  { label: 'MARKET OBSERVATION', tag: 'INGEST' },
  { label: 'CONDITION CHECK', tag: 'FILTER' },
  { label: 'ENTRY DECISION', tag: 'FILTER' },
  { label: 'RISK CHECK', tag: 'FILTER' },
  { label: 'MT5 EXECUTION', tag: 'EXECUTE' },
  { label: 'POSITION MANAGEMENT', tag: 'EXECUTE' },
  { label: 'TRADE RESULT', tag: 'RECORD' },
];

function DecisionEngine() {
  const [lit, setLit] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setLit((v) => {
        if (v >= nodes.length) {
          window.clearInterval(timer);
          return v;
        }
        return v + 1;
      });
    }, 300);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className="w-full rounded-lg border border-background-300 bg-background-50 overflow-hidden">
      <div className="flex items-center justify-between px-4 md:px-5 h-12 border-b border-background-200 bg-background-100">
        <span className="text-[12px] font-data tracking-widest text-foreground-700">
          EA DECISION ENGINE
        </span>
        <span className="flex items-center gap-2">
          <span className="w-1.5 h-1.5 rounded-full bg-primary-500 breathe"></span>
          <span className="text-[10px] font-data tracking-widest text-primary-600">SEQUENCE</span>
        </span>
      </div>

      <div className="px-4 md:px-5 py-5">
        <div className="flex flex-col">
          {nodes.map((node, idx) => {
            const active = idx < lit;
            const isLast = idx === nodes.length - 1;
            return (
              <div key={node.label}>
                <div
                  className={`flex items-center gap-3 rounded-md border px-3.5 py-2.5 transition-all duration-500 ${
                    active
                      ? 'border-primary-300 bg-primary-50'
                      : 'border-background-200 bg-background-50'
                  }`}
                >
                  <span
                    className={`w-6 h-6 rounded-full border flex items-center justify-center shrink-0 transition-all duration-500 ${
                      active
                        ? 'border-primary-500 bg-primary-500'
                        : 'border-background-300 bg-background-50'
                    }`}
                  >
                    {active ? (
                      <i className="ri-check-line text-[12px] text-background-50"></i>
                    ) : (
                      <span className="text-[10px] font-data text-foreground-400">{idx + 1}</span>
                    )}
                  </span>
                  <span
                    className={`flex-1 text-[12px] md:text-[13px] font-data tracking-wider transition-colors duration-500 ${
                      active ? 'text-foreground-950' : 'text-foreground-400'
                    }`}
                  >
                    {node.label}
                  </span>
                  <span
                    className={`text-[9px] font-data tracking-widest transition-colors duration-500 ${
                      active ? 'text-primary-600' : 'text-foreground-300'
                    }`}
                  >
                    {node.tag}
                  </span>
                </div>
                {!isLast && (
                  <div className="flex justify-center">
                    <span
                      className={`w-px h-4 transition-colors duration-500 ${
                        idx < lit - 1 ? 'bg-primary-400' : 'bg-background-300'
                      }`}
                    ></span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default DecisionEngine;